import React from 'react'

import { Button } from '@mui/material'

const RetryReport = ({ fetchReport, sectionNum }) => {
  return (
    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '200px'}}>
        <p>Ocurrió un error al consultar la información del reporte.</p>
        <Button onClick={() => fetchReport(sectionNum)}>Reintentar</Button>
    </div>
  )
}

export default RetryReport